module.exports = __webpack_public_path__ + "img/framework.c161cc73.png";